export type EventHandler = (result?: any) => void

export interface LogoImage {
    src: string
}

export type LogoSet = {
    alt: string
    large: LogoImage
    medium: LogoImage
    small: LogoImage
    // Add other sizes if needed
}

export enum LoginStateTypes {
    initialising = 'initialising',
    initialised = 'initialised',
    isLoggedIn = 'isLoggedIn',
    isLoggedInLoading = 'isLoggedInLoading',
    loginModalOpen = 'loginModalOpen',
    requestCode = 'requestCode',
    enterLoginCode = 'enterLoginCode',
    optCodeSubmited = 'optCodeSubmited',
    optFailed = 'optFailed',
}

export interface FormChangeDetail {
    formData: Record<string, any>;
    userEmail?: string | null | undefined;
}